export default [{
    path: '/deviceType',
    name: 'deviceType',
    meta: {
      layout: 'main'
    },
    component: () => import('@/views/deviceType/index')
  }]
